module.exports = __webpack_public_path__ + "static/media/logo.d6c587e3.svg";